// @flow
import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'

import { Input, Flex } from '../'
import { ControllerError } from './'

type InputControllerProps = {
  name: string,
  label?: string,
  autocomplete?: string,
  isDisabled?: boolean,
  defaultValue?: any,
  rules?: {
    [key: string]: any
  },
  wrapperProps?: {
    [key: string]: any
  },
  transformValue?: (value: any) => string,
  transformOutput?: (value: string) => any
}

const InputController = ({
  autocomplete = 'off',
  label,
  name,
  rules,
  isDisabled,
  defaultValue,
  wrapperProps,
  transformValue,
  transformOutput,
  ...props
}: InputControllerProps) => {
  const { errors } = useFormContext()

  return (
    <Flex column {...wrapperProps}>
      <Controller
        defaultValue={defaultValue}
        name={name}
        render={({ field: { onChange, value = '' } }) => {
          return (
            <Input
              autoComplete={autocomplete}
              disabled={isDisabled}
              id={`${name}-input`}
              label={label}
              max={rules?.max?.value}
              min={rules?.min?.value}
              value={typeof transformValue === 'function' ? transformValue(value) : value}
              onChange={value => onChange(typeof transformOutput === 'function' ? transformOutput(value) : value)}
              {...props}
            />
          )
        }}
        rules={rules}
      />
      <ControllerError errors={errors} name={name} />
    </Flex>
  )
}

export { InputController }
